import { UserAPI } from "../api";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';

export class User {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
      if (this.projects && this.projects.length) {
        for (let project of this.projects) {
          project.packageStartDateText = project.packageStartDate ? moment(project.packageStartDate.iso).format('DD/MM/YYYY') : '-'
          project.packageEndDateText = project.packageEndDate ? moment(project.packageEndDate.iso).format('DD/MM/YYYY') : '-'
          project.packageEndDateDays = project.packageEndDate ? dayMonthYearText(project.packageEndDate) : '-'
          project.isPackageExpired = project.packageEndDate ? moment(project.packageEndDate.iso).endOf('days').isSameOrBefore(moment()) : null
        }
      }
      if (this.admins && this.admins.length) {
        for (let admin of this.admins) {
          let project = admin.project
          project.packageStartDateText = project.packageStartDate ? moment(project.packageStartDate.iso).format('DD/MM/YYYY') : '-'
          project.packageEndDateText = project.packageEndDate ? moment(project.packageEndDate.iso).format('DD/MM/YYYY') : '-'
          project.packageEndDateDays = project.packageEndDate ? dayMonthYearText(project.packageEndDate) : '-'
          project.isPackageExpired = project.packageEndDate ? moment(project.packageEndDate.iso).endOf('days').isSameOrBefore(moment()) : null
        }
      }
      if (this.employees && this.employees.length) {
        for (let employee of this.employees) {
          let project = employee.project
          project.packageStartDateText = project.packageStartDate ? moment(project.packageStartDate.iso).format('DD/MM/YYYY') : '-'
          project.packageEndDateText = project.packageEndDate ? moment(project.packageEndDate.iso).format('DD/MM/YYYY') : '-'
          project.packageEndDateDays = project.packageEndDate ? dayMonthYearText(project.packageEndDate) : '-'
          project.isPackageExpired = project.packageEndDate ? moment(project.packageEndDate.iso).endOf('days').isSameOrBefore(moment()) : null
        }
      }
    }
  }
  static async changeUserPassword(payload) {
    const { data } = await UserAPI.changeUserPassword(payload);
    // Array Return
    // return data.result.map((item) => new User(item));
    // Object Return
    return data.result = new User(data.result)
  }
  static async updateUser(payload) {
    const { data } = await UserAPI.updateUser(payload);
    return data.result = new User(data.result)
  }
  static async getUserInfo(payload) {
    const { data } = await UserAPI.getUserInfo(payload);
    data.result = new User(data.result);
    return data.result;
  }
  static async logIn(payload) {
    const { data } = await UserAPI.logIn(payload);
    return data;
  }
  static async signUp(payload) {
    const { data } = await UserAPI.signUp(payload);
    return data;
  }
  static async logOut(payload) {
    const { data } = await UserAPI.logOut(payload);
    return data;
  }
  static async getUserByTel(tel) {
    const { data } = await UserAPI.getUserByTel(tel);
    return data.result.map((item) => (item = new User(item)));
  }
  static async loginSSO(payload) {
    const { data } = await UserAPI.loginSSO(payload);
    return data.result;
  }
  static async become() {
    const { data } = await UserAPI.become();
    return data;
  }

  get fullName() {
    return `${this.firstName || ''} ${this.lastName || ''}`
  }

}

function dayMonthYearText(packageEndDate) {
  let days = 0;
  let months = 0;
  let years = 0;
  let text = "";
  let number = 0
  if (packageEndDate && packageEndDate.iso) {
    let a = moment(packageEndDate.iso, "YYYY-MM-DD").endOf("day");
    let b = moment().startOf("day");
    a.add(1, "days");
    number = a.diff(b, "days");
    years = a.diff(b, "year");
    b.add(years, "years");
    months = a.diff(b, "months");
    b.add(months, "months");
    days = a.diff(b, "days");
  }
  if (years) {
    text += `${years} ${i18n.t('year')} `;
  }
  if (months) {
    text += `${months} ${i18n.t('month')} `;
  }
  if (days) {
    text += `${days} ${i18n.t('day')}`;
  }
  return { text, number };
}
